import { convertOpenAICitationsToMarkdownSuperScripts } from '../components/DealGPT/SourcesDisplay';
import { Message } from '../Types/conversation';
import { ToolName } from '../Types/enums';
import { ToolConfig } from './tools';

function convertLatexDelimiters(text: string): string {
  // Function to check if content looks like a formula
  const isLikelyFormula = (content: string): boolean => {
    // Check for common math symbols and patterns
    const mathPatterns = [
      /[+*/^=<>≤≥≈≠∑∏∫√]/, // Basic math operators and symbols
      /\\[a-zA-Z]+/, // LaTeX commands
      /[a-zA-Z]_\{[^}]+\}/, // Subscripts
      /[a-zA-Z]\^[2-9]/, // Superscripts
      /\{.+\}/, // Curly braces (common in LaTeX)
      /\\frac/, // Fractions
    ];
    return mathPatterns.some((pattern) => pattern.test(content));
  };

  // Escape dollar sign to prevent LaTeX interpretations
  text = text.replace(/\$/g, '\\$');

  // Replace display math \[...\]
  text = text.replace(/\\\[([\s\S]*?)\\\]/g, (_, content) => {
    return `$${content.trim()}$`;
  });

  // Replace inline math \(...\) and (likely formula)
  text = text.replace(/\\\(([^()]*(?:\([^()]*\)[^()]*)*)\\\)/g, (match, p1, p2) => {
    if (p1) {
      // This was \(...\)
      return `$${p1.trim()}$`;
    } else if (isLikelyFormula(p2)) {
      // This was (...) and looks like a formula
      return `$${p2.trim()}$`;
    } else {
      // This was (...) but doesn't look like a formula
      return match;
    }
  });

  return text;
}

export const renderMessage = (message: Partial<Message>) => {
  let messageText = convertLatexDelimiters(message.message ?? '');
  if (message.citations && message.citations.length > 0) {
    const formatToMarkdown = (text: string, links: string[]): string => {
      const markdownLinks = links.map((citation) => `- ${citation}`).join('\n');
      return `${text}\n\nCitations:\n${markdownLinks}\n`;
    };
    return formatToMarkdown(messageText ?? '', message.citations);
  }
  messageText = convertOpenAICitationsToMarkdownSuperScripts(messageText ?? '');

  return messageText;
};

export const deepResearchToolsTooltipMessage = (tool: ToolName, appliedTools: ToolName[]) => {
  if (appliedTools.includes(ToolName.DEEP_RESEARCH) && !ToolConfig[tool].deepResearchSupport) {
    return `Deep Research does not support the use of ${ToolConfig[tool].name}`;
  }

  if (tool === ToolName.WEB_SEARCH && appliedTools.includes(ToolName.DEEP_RESEARCH)) {
    return 'Web Search is included with Deep Research';
  }

  return '';
};
